export default '/build/717f43e5.svg'